import { defineRule } from 'vee-validate'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import { i18n } from '@/i18n.js'

defineRule('checkValidPhoneNumber', (value, args) => {
  if ((value === '' || value === null) && (args?.[0] === '' || args?.[0] === null)) {
    return true
  }
  if ((!value || value.length < 2) && !args[0]?.dial_code) {
    return i18n.global.t('errors.phoneNotValid')
  }
  const dial = args?.[0]?.dial_code ? args[0].dial_code : args[0]
  const number = parsePhoneNumberFromString(dial + value)
  if (number?.isValid()) {
    return true
  } else {
    return i18n.global.t('errors.phoneNotValid')
  }
})
